import request from "@/utils/request";
// const BASE_URL = process.env.VUE_APP_BASE_API + "";
import { post, getRequest, postRequest, deleteRequest } from '@/utils/axios'

export function login(data) {
    var params = {
      username: data.username,
      password: data.password,
      saveLogin: data.saveLogin
    }
    //console.log('登录数据：'+JSON.stringify(params))
    return request({
      url: '/sys/user/login',
      method: 'post',
      params: params
    })
  }

  export function loginByPhone(data) {
    var params = {
      username: data.username,
      password: data.password,
      saveLogin: data.saveLogin,
      usertype:2
    }
    return post( '/user/loginByPhone', params)
  }

  export function findPhoneByUserName(data) {
    var params = {
      username: data.username,
      password: data.password,
      saveLogin: data.saveLogin,
      usertype:2
    }
    return post( '/user/findPhoneByUserName', params)
  }
  

  export function loginByPhoneVerifyCode(params) {
    return post( '/user/loginByPhoneVerifyCode', params)
  }
  
  export function loginByPhoneVerifyCodeZ(params) {
    return post( '/user/loginByPhoneVerifyCodeZ', params)
  }

  export function editPassPhone(params) {
    return post('/loginController/editPassPhone', params)
  }

  export function editUserPass(params) {
    return post('/loginController/editUserPass', params)
  }

  export function getUserInfoCW(params) {
    return getRequest('/user/getUserInfoCW', params)
  }
  export function SendMessage(params) {
    return post('/SendSmsController/SendMessage', params)
  }
// 修改手机号
  export function modifyUserPhone(params) {
    return post('/user/modifyUserPhone', params)
  }

// 根据手机号登录
export function findPhonebyUserInfo(params) {
    return post('/user/findPhonebyUserInfo', params)
  }


// WEBPACK FOOTER //
// ./src/api/login.js